// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__0vzli","inverse":"button_inverse__WfWh_","small":"button_small__2H3ru","disabled":"button_disabled__QijIz"};